import loadable from '@loadable/component'

export default [
  {
    path: '/FightMonster',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FightMonster" */ '~/pages/FightMonster'
        )
    ),
  },
  {
    // 这里的webpackChunkName不要忘记修改
    path: '/FightMonster/RoomModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FightMonster-RoomModal" */ '~/pages/FightMonster/components/RoomModal'
        )
    ),
  },
]
